export const roundOneDecimal = (n) => Math.round(n * 10) / 10;

export const formatPct = (n) => `${roundOneDecimal(n).toFixed(1)}%`;

export const scoreColor = (score) => {
  if (score >= 70) return "green";
  if (score >= 40) return "yellow";
  return "orange";
};
